import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr'
import Settings from './Settings';
import loginUser from './userdetails'
import toastermsg from './toastermsg'
import { getAddUserRoleLookup } from './lookup'
import { teamDetails } from './teamdetails'
import { templateDetails } from './templatedetails'
import { userDetails } from './userdetails'
import { getCustomerList, getCustomer, addCustomer } from './customerdetails'
import { meetingDetails } from './meetingdetails'
import { agendaitemDetails } from './agendaitemdetails'
import { documentDetails } from './documentdetails'
import fileupload from './fileupload'
import {resolutionDetails} from './resolutiondetails'
import {assigneeDetails} from './assigneedetails'
import {decisionDetails} from './decisiondetails'
import {archiveDetails} from './archivedetails'
import {auditDetails} from './auditdetails'
import {esignatureDetails} from './esignaturedetails'
import {dashboardDetails} from './dashboardDetails'
import {mailDetails} from './mailDetails'

const reducers = combineReducers({
    routing: routerReducer,
    toastr: toastrReducer,
    settings: Settings,
    loginUser: loginUser,
    toastermsg: toastermsg,
    getAddUserRoleLookup,
    teamDetails,
    templateDetails,
    userDetails,
    getCustomerList,
    getCustomer,
    addCustomer,
    meetingDetails,
    agendaitemDetails,
    documentDetails,
    fileupload,
    resolutionDetails,
    assigneeDetails,
    decisionDetails,
    archiveDetails,
    auditDetails,
    esignatureDetails,
    dashboardDetails,
    mailDetails,
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js